import { render, staticRenderFns } from "./diction.vue?vue&type=template&id=4197622f&scoped=true"
import script from "./diction.vue?vue&type=script&lang=js"
export * from "./diction.vue?vue&type=script&lang=js"
import style0 from "./diction.vue?vue&type=style&index=0&id=4197622f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4197622f",
  null
  
)

export default component.exports